module.exports = __WEBPACK_EXTERNAL_MODULE_167__;


//////////////////
// WEBPACK FOOTER
// external "@angular/core"
// module id = 167
// module chunks = 0